export function screenerCells(type) {
	return [
		{
			id: 'ScreenerNumber',
			sortable: true,
			align: 'left',
			disablePadding: true,
			label: 'Screener #',
		},
		{
			id: 'Account',
			sortable: true,
			align: 'center',
			disablePadding: false,
			label: 'Account',
		},
		{
			id: 'Name',
			sortable: true,
			align: 'center',
			disablePadding: false,
			label: 'Screener Name',
		},
		{
			id: 'Status',
			sortable: true,
			align: 'center',
			disablePadding: false,
			label: 'Status',
		},
	];
}
